import type { WorkspaceUser } from "@procurement-agents/auth";

/** The user's first name: the `name` claim when the identity provider sends one, otherwise the first word of the
 *  email's local part ("madhu.augustine@…" → "Madhu"). Null when neither gives a usable word. */
export function firstName(user: Pick<WorkspaceUser, "name" | "email"> | null): string | null {
  const fromName = user?.name?.trim().split(/\s+/)[0]?.replace(/[^\p{L}\p{M}'’-]/gu, "");
  if (fromName) return fromName;
  const local = user?.email?.split("@")[0] ?? "";
  const word = local.split(/[._+\-\d]/).find((w) => /^\p{L}+$/u.test(w));
  return word ? word.charAt(0).toUpperCase() + word.slice(1).toLowerCase() : null;
}

/** "Good morning, Madhu" — morning until noon, afternoon until six, evening after. Without a name, just the greeting. */
export function greeting(hour: number, name: string | null): string {
  const part = hour < 12 ? "morning" : hour < 18 ? "afternoon" : "evening";
  return name ? `Good ${part}, ${name}` : `Good ${part}`;
}
